import { Plus } from "lucide-react";

import styles from "./SelectMedicationsTable.module.css";

export const SelectMedicationsTableItem = ({ item, selectDrug }) => {
  return (
    <>
      <li className={styles.tableItem}>
        <p aria-describedby="results-table-trade-name">
          {item.tradeName || "-"}
        </p>
        <p aria-describedby="results-table-generic-name">
          {item.genericName || "-"}
        </p>
        <p aria-describedby="results-table-manufacturer">
          {item.manufacturer || "-"}
        </p>
        <p aria-describedby="results-table-strength">{item.strength || "-"}</p>
        <p aria-describedby="results-table-pack">{item.packSize || "-"}</p>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <span
            className={styles.openAll}
            style={{ flexGrow: 1 }}
            onClick={() => selectDrug(item)}
          >
            Add <Plus style={{ width: "16px", height: "16px" }} />
          </span>
        </div>
      </li>
    </>
  );
};
